/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { classnames } from "../../utils/text";
import Select from "react-select";
import { isEmpty } from "../../utils/lodashExtend";

const SearchSelect = ({
  name,
  placeholder,
  onChange,
  list,
  className,
  disabled,
  menuPlacement,
  value,
  defaultValue,
  height = "54px",
  zIndex = 1,
  isControlShouldRenderValue = false,
  isClearable = false,
  lineHeight,
}) => {


  const [_defaultValue, _setDefaultValue] = useState(value);
  const [_value, _setValue] = useState(value);

  useEffect(() => {
    const target = list.find(item => item.value === defaultValue);
    if (target) {
      _setDefaultValue(target);
    }
  }, [defaultValue, list]);

  useEffect(() => {
    !isEmpty(list) && _setValue(list.find(item => item.value === value));
  }, [value, list]);

  const customStyles = {
    control: (provided) => {
      return {
        // ...provided,
        "&:hover": { borderColor: '#21D4A9' },
        flexWrap: "wrap",
        label: "control",
        position: "relative",
        boxSizing: "border-box",
        transition: "all 100ms",

        display: "flex",
        maxHeight: height,
        border: "1px solid #F1F4F8",
        borderRadius: "7px",
        fontSize: "15px",
        padding: "0 8px",
      };
    },
    menu: (provided, state) => {
      return {
        ...provided,
        color: "#4A5673",
        zIndex,
      };
    },
    singleValue: (provided, state) => {
      return {
        ...provided,
        color: "#4A5673",
      };
    },

    valueContainer: (provided, state) => {
      return {
        ...provided,
        maxHeight: height,
      };
    },
    input: (provided, state) => ({
      ...provided,
      maxHeight: height,
      margin: 0,
      padding: 0,
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      maxHeight: height,
    }),
  };

  return (
    <Select
      value={_value}
      styles={customStyles}
      name={name}
      classNamePrefix={classnames("component-search-select", className)}
      placeholder={placeholder}
      onChange={onChange}
      options={list}
      isDisabled={disabled}
      menuPlacement={menuPlacement}
      defaultValue={_defaultValue}
      controlShouldRenderValue={isControlShouldRenderValue}
      isClearable={isClearable}
    />
  );
};
export default SearchSelect;
